export class Validation {
    static canSubmit(selectedGiftCardOption, hasAcceptedTermsAndConditions) {
        return selectedGiftCardOption && hasAcceptedTermsAndConditions;
    }
}
